module.exports = __webpack_public_path__ + "static/media/pa-icons-2@3x.618a7847.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pa-icons-2@3x.png
// module id = 1721
// module chunks = 0